import { render, staticRenderFns } from "./UsefulDocuments.vue?vue&type=template&id=8edc0e24&"
import script from "./UsefulDocuments.vue?vue&type=script&lang=js&"
export * from "./UsefulDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports